import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const NEWS_BLOCK_RECEIVE = "NEWS_BLOCK_RECEIVE";
export const NEWS_BLOCK_ERROR = 'NEWS_BLOCK_ERROR';

export const fetchNewsModel = (id) => (dispatch) => {
    return get('/api/newsblock/' + id)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: NEWS_BLOCK_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: NEWS_BLOCK_ERROR,
    payload: {
        error,
    },
})